import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

export const initState = {
  userId: undefined,
  email: undefined,
  fullname: undefined,
  username: undefined,
  position: { id: undefined, name: undefined },
  department: { id: undefined, name: undefined },
  avatar: undefined,
  iat: undefined,
  exp: undefined,
  msToken: undefined,
  token: undefined,
};

const state = {
  ...initState,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
